import React from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { Header } from '../../layout/Header';
import { MyGigsHeader } from './MyGigsHeader';
import { InquiriesTab } from './inquiries/InquiriesTab';
import { ApplicantsTab } from './applicants/ApplicantsTab';
import { OffersTab } from './offers/OffersTab';
import { PaymentHistoryTab } from './payment-history/PaymentHistoryTab';
import type { MyGigsTab } from './types';
import { useGetServiceApplications } from '../../../api/services';
import { useGetGigApplications } from '../../../api/queries';
import { useOffersList } from '../../../api/offers';

export const MyGigsPage: React.FC = () => {
  const navigate = useNavigate();
  const search = useSearch({ from: '/profile/my-gigs' });
  const activeTab: MyGigsTab = search.tab ?? 'inquiries';

  const setActiveTab = (tab: MyGigsTab) => {
    navigate({
      to: '/profile/my-gigs',
      search: { tab },
      replace: true,
    });
  };

  // Fetch real counts for top navigation tabs
  const { data: serviceAppsData } = useGetServiceApplications();
  const { data: gigAppsData } = useGetGigApplications({ page: 1, page_size: 1000 });
  const { data: offersCreated } = useOffersList({ perspective: 'created', page: 1, page_size: 1 });
  const { data: offersReceived } = useOffersList({
    perspective: 'received',
    page: 1,
    page_size: 1,
  });

  const inquiriesCount =
    serviceAppsData?.counts?.all ??
    serviceAppsData?.data?.count ??
    serviceAppsData?.data?.results?.length ??
    0;

  const applicantsCount =
    gigAppsData?.counts?.all ?? gigAppsData?.data?.count ?? gigAppsData?.data?.results?.length ?? 0;

  const offersCount = (offersCreated?.count ?? 0) + (offersReceived?.count ?? 0);

  return (
    <div className="min-h-screen bg-black text-white pb-28">
      <Header />

      <main className="mx-auto max-w-[1360px] px-4 sm:px-6 lg:px-8 pt-[calc(var(--header-height,5.5rem)+1.75rem)]">
        <MyGigsHeader
          activeTab={activeTab}
          onTabChange={setActiveTab}
          inquiriesCount={inquiriesCount}
          applicantsCount={applicantsCount}
          offersCount={offersCount}
        />

        {activeTab === 'inquiries' && <InquiriesTab />}
        {activeTab === 'applicants' && <ApplicantsTab />}
        {activeTab === 'offers' && <OffersTab />}
        {activeTab === 'payment_history' && <PaymentHistoryTab />}
      </main>
    </div>
  );
};
